import { render, staticRenderFns } from "./OnlineClassSetting.vue?vue&type=template&id=51ccf4db&scoped=true&"
import script from "./OnlineClassSetting.vue?vue&type=script&lang=js&"
export * from "./OnlineClassSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ccf4db",
  null
  
)

export default component.exports